export const freePortingCountryCodes: string[] = [
  'AU',
  'BE',
  'BR',
  'CA',
  'CL',
  'CZ',
  'DK',
  'FI',
  'FR',
  'DE',
  'GR',
  'IE',
  'IL',
  'IT',
  'LV',
  'LT',
  'LU',
  'MX',
  'NL',
  'NZ',
  'PA',
  'PE',
  'PR',
  'RO',
  'SK',
  'SI',
  'ZA',
  'ES',
  'SE',
  'CH',
  'GB',
  'US'
];
